import { UseQueryResult, useMutation, useQuery } from '@tanstack/react-query'

import { delayedFunction } from '~/utils/utilityFunctions'

import { api } from './api-client'

import { Reports } from '~/types/api'

export const useStats = (): UseQueryResult<Reports[], Error> => {
  const fetchStats = async (): Promise<Reports[]> => {
    const res = await api.get<Reports[]>('/rh/company_periods')
    return res.data
  }
  return useQuery<Reports[], Error>({
    queryKey: ['company_periods'],
    queryFn: delayedFunction(fetchStats, 300),
    staleTime: 1,
  })
}

export const useDownloadStat = () => {
  const downloadStat = async (filename: string): Promise<{ url_pptx: string; url_pdf: string }> => {
    const res = await api.get(`/rh/company_periods/${filename}`)
    return res.data
  }
  return useMutation({
    mutationKey: ['company_periods'],
    mutationFn: (filename: string) => downloadStat(filename),
  })
}
